import UtilService from '../services/util';
import store from '../store/index';

const initialState = {
  userId: null,
  unreadMessages: 0,
  appMessages: [],
  invites: [],
};

export const message = {
  namespaced: true,
  state: initialState,
  actions: {
    setInitialMessages({ commit }, data) {
      commit('setInitialMessages', data);
      commit('setInvitedMessages', data);
    },

    setMessage({ commit }, data) {
      commit('setMessage', data);
    },

    pushNewMessage({ commit }, data) {
      commit('pushNewMessage', data);
    },

    setInvites({ commit }, data) {
      commit('setInvites', data);
    },
  },
  mutations: {
    setUnread(state) {
      state.unreadMessages = state.appMessages.filter((message) => {
        return (
          (store.state.application.courseMapModerator.filter(
            (course) =>
              course.title === message.courseTitle &&
              course.moderatorId &&
              course.moderatorId.includes(state.userId)
          ).length ||
            state.userId === message.applicationModeratorId ||
            state.invites.filter(
              (message) =>
                message.applicationId === message.appId &&
                message.inviteModeratorId === state.userId
            ).length) &&
          message.isUnread &&
          message.moderatorId !== state.userId
        );
      }).length;
    },

    setInvitedMessages(state, data) {
      state.invites = data.messages
        .map((application) => application.application_messages_invites)
        .flat();
    },

    setInitialMessages(state, data) {
      state.userId = data.userId;
      let appMessages = [];
      data.messages.map((application) => {
        const appMessage = application.application_messages.map((message) => {
          return {
            ...message,
            applicationModeratorId: application.moderatorId,
            studentName:
              application.studentData.personalInformation.student_name,
            appId: application.id,
            studentId: application.studentId,
            advisorName: message.moderatorName,
            courseDocuments: application.courseData.documents,
            courseTitle: application.courseTitle,
            isApproved: application.isApproved,
          };
        });

        if (appMessage && appMessage.length) {
          appMessages.push(appMessage);
        }
      });

      state.appMessages = appMessages.flat(1);

      this.commit('message/setUnread');
    },

    messageFailure() {},

    setMessage(state, response) {
      const seenIds = response.message.ids;
      const isUnread = response.message.isUnread;
      state.appMessages = [...state.appMessages].map((p) =>
        seenIds.includes(p.id)
          ? {
              ...p,
              isUnread,
            }
          : p
      );

      this.commit('message/setUnread');
    },

    setInvites(state, data) {
      state.invites = data;
    },

    pushNewMessage(state, newApplication) {
      state.appMessages.push(newApplication);
      this.commit('message/setUnread');
    },
  },
};
